
export const themes = {
  light: {
    name: 'پیش‌فرض',
    type: 'light',
    colors: {
      '--color-primary': '#4f46e5',
      '--color-secondary': '#000000',
      '--color-background': '#f8f9fa',
      '--color-background-2': '#ffffff',
      '--color-text-primary': '#333333',
      '--color-text-secondary': '#666666',
      '--color-border': '#e1e5e9',
      '--color-landing-bg': 'rgb(235, 235, 235)',
      '--color-landing-card': '#D7D7D7',
      '--color-landing-dark-bg': '#7C7C7C',
      '--color-button-bg': '#343434',
      '--color-gray-footer': '#666666'
    }
  },
  blue: {
    name: 'آبی',
    type: 'light',
    colors: {
      '--color-primary': '#3b82f6',
      '--color-secondary': '#1e40af',
      '--color-background': '#eff6ff',
      '--color-background-2': '#ffffff',
      '--color-text-primary': '#1e3a8a',
      '--color-text-secondary': '#1e40af',
      '--color-border': '#dbeafe',
      '--color-landing-bg': '#e0f2fe',
      '--color-landing-card': '#bae6fd',
      '--color-landing-dark-bg': '#0284c7',
      '--color-button-bg': '#1e40af',
      '--color-gray-footer': '#2a569d'
    }
  },
  sky: {
    name: 'آسمانی',
    type: 'light',
    colors: {
      '--color-primary': '#0ea5e9',
      '--color-secondary': '#0369a1',
      '--color-background': '#f0f9ff',
      '--color-background-2': '#ffffff',
      '--color-text-primary': '#0c4a6e',
      '--color-text-secondary': '#0369a1',
      '--color-border': '#e0f2fe',
      '--color-landing-bg': '#e0f2fe',
      '--color-landing-card': '#bae6fd',
      '--color-landing-dark-bg': '#0284c7',
      '--color-button-bg': '#0369a1',
      '--color-gray-footer': '#004971'
    }
  },
  ocean: {
    name: 'اقیانوس',
    type: 'light',
    colors: {
      '--color-primary': '#06b6d4',
      '--color-secondary': '#0e7490',
      '--color-background': '#ecfeff',
      '--color-background-2': '#ffffff',
      '--color-text-primary': '#164e63',
      '--color-text-secondary': '#0e7490',
      '--color-border': '#a5f3fc',
      '--color-landing-bg': '#cffafe',
      '--color-landing-card': '#a5f3fc',
      '--color-landing-dark-bg': '#0e7490',
      '--color-button-bg': '#0e7490',
      '--color-gray-footer': '#57bfca'
    }
  },
  green: {
    name: 'سبز',
    type: 'light',
    colors: {
      '--color-primary': '#10b981',
      '--color-secondary': '#047857',
      '--color-background': '#ecfdf5',
      '--color-background-2': '#ffffff',
      '--color-text-primary': '#064e3b',
      '--color-text-secondary': '#047857',
      '--color-border': '#a7f3d0',
      '--color-landing-bg': '#d1fae5',
      '--color-landing-card': '#a7f3d0',
      '--color-landing-dark-bg': '#059669',
      '--color-button-bg': '#047857',
      '--color-gray-footer': '#106d32'
    }
  },
  forest: {
    name: 'جنگل',
    type: 'light',
    colors: {
      '--color-primary': '#16a34a',
      '--color-secondary': '#166534',
      '--color-background': '#f0fdf4',
      '--color-background-2': '#ffffff',
      '--color-text-primary': '#14532d',
      '--color-text-secondary': '#166534',
      '--color-border': '#bbf7d0',
      '--color-landing-bg': '#dcfce7',
      '--color-landing-card': '#bbf7d0',
      '--color-landing-dark-bg': '#15803d',
      '--color-button-bg': '#166534',
      '--color-gray-footer': '#106d32'
    }
  },
  mint: {
    name: 'نعناعی',
    type: 'light',
    colors: {
      '--color-primary': '#34d399',
      '--color-secondary': '#065f46',
      '--color-background': '#f0fdf9',
      '--color-background-2': '#ffffff',
      '--color-text-primary': '#065f46',
      '--color-text-secondary': '#047857',
      '--color-border': '#6ee7b7',
      '--color-landing-bg': '#ccfbf1',
      '--color-landing-card': '#99f6e4',
      '--color-landing-dark-bg': '#0d9488',
      '--color-button-bg': '#065f46',
      '--color-gray-footer': '#66ffb0'
    }
  },
  emerald: {
    name: 'زمردی',
    type: 'light',
    colors: {
      '--color-primary': '#10b981',
      '--color-secondary': '#047857',
      '--color-background': '#ecfdf5',
      '--color-background-2': '#ffffff',
      '--color-text-primary': '#064e3b',
      '--color-text-secondary': '#047857',
      '--color-border': '#a7f3d0',
      '--color-landing-bg': '#d1fae5',
      '--color-landing-card': '#a7f3d0',
      '--color-landing-dark-bg': '#059669',
      '--color-button-bg': '#047857',
      '--color-gray-footer': '#10b981'
    }
  },
  lime: {
    name: 'لیمویی',
    type: 'light',
    colors: {
      '--color-primary': '#84cc16',
      '--color-secondary': '#4d7c0f',
      '--color-background': '#f7fee7',
      '--color-background-2': '#ffffff',
      '--color-text-primary': '#3f6212',
      '--color-text-secondary': '#4d7c0f',
      '--color-border': '#bef264',
      '--color-landing-bg': '#ecfccb',
      '--color-landing-card': '#d9f99d',
      '--color-landing-dark-bg': '#65a30d',
      '--color-button-bg': '#4d7c0f',
      '--color-gray-footer': '#84cc16'
    }
  },
  yellow: {
    name: 'زرد',
    type: 'light',
    colors: {
      '--color-primary': '#eab308',
      '--color-secondary': '#a16207',
      '--color-background': '#fefce8',
      '--color-background-2': '#ffffff',
      '--color-text-primary': '#854d0e',
      '--color-text-secondary': '#a16207',
      '--color-border': '#fde047',
      '--color-landing-bg': '#fef9c3',
      '--color-landing-card': '#fef08a',
      '--color-landing-dark-bg': '#ca8a04',
      '--color-button-bg': '#a16207',
      '--color-gray-footer': '#7f5700'
    }
  },
  gold: {
    name: 'طلایی',
    type: 'light',
    colors: {
      '--color-primary': '#f59e0b',
      '--color-secondary': '#92400e',
      '--color-background': '#fffbeb',
      '--color-background-2': '#ffffff',
      '--color-text-primary': '#78350f',
      '--color-text-secondary': '#92400e',
      '--color-border': '#fbbf24',
      '--color-landing-bg': '#fef3c7',
      '--color-landing-card': '#fde68a',
      '--color-landing-dark-bg': '#d97706',
      '--color-button-bg': '#92400e',
      '--color-gray-footer': '#7f5700'
    }
  },
  orange: {
    name: 'نارنجی',
    type: 'light',
    colors: {
      '--color-primary': '#f97316',
      '--color-secondary': '#9a3412',
      '--color-background': '#fff7ed',
      '--color-background-2': '#ffffff',
      '--color-text-primary': '#7c2d12',
      '--color-text-secondary': '#9a3412',
      '--color-border': '#fdba74',
      '--color-landing-bg': '#fed7aa',
      '--color-landing-card': '#fdba74',
      '--color-landing-dark-bg': '#ea580c',
      '--color-button-bg': '#9a3412',
      '--color-gray-footer': '#9c4a10'
    }
  },
  amber: {
    name: 'کهربایی',
    type: 'light',
    colors: {
      '--color-primary': '#f59e0b',
      '--color-secondary': '#92400e',
      '--color-background': '#fffbeb',
      '--color-background-2': '#ffffff',
      '--color-text-primary': '#78350f',
      '--color-text-secondary': '#92400e',
      '--color-border': '#fbbf24',
      '--color-landing-bg': '#fef3c7',
      '--color-landing-card': '#fde68a',
      '--color-landing-dark-bg': '#d97706',
      '--color-button-bg': '#92400e',
      '--color-gray-footer': '#f59e0b'
    }
  },
  red: {
    name: 'قرمز',
    type: 'light',
    colors: {
      '--color-primary': '#ef4444',
      '--color-secondary': '#991b1b',
      '--color-background': '#fef2f2',
      '--color-background-2': '#ffffff',
      '--color-text-primary': '#7f1d1d',
      '--color-text-secondary': '#991b1b',
      '--color-border': '#fca5a5',
      '--color-landing-bg': '#fee2e2',
      '--color-landing-card': '#fecaca',
      '--color-landing-dark-bg': '#dc2626',
      '--color-button-bg': '#991b1b',
      '--color-gray-footer': '#ef4444'
    }
  },
  rose: {
    name: 'رز',
    type: 'light',
    colors: {
      '--color-primary': '#f43f5e',
      '--color-secondary': '#be123c',
      '--color-background': '#fff1f2',
      '--color-background-2': '#ffffff',
      '--color-text-primary': '#881337',
      '--color-text-secondary': '#be123c',
      '--color-border': '#fda4af',
      '--color-landing-bg': '#ffe4e6',
      '--color-landing-card': '#fecdd3',
      '--color-landing-dark-bg': '#e11d48',
      '--color-button-bg': '#be123c',
      '--color-gray-footer': '#f43f5e'
    }
  },
  pink: {
    name: 'صورتی',
    type: 'light',
    colors: {
      '--color-primary': '#ec4899',
      '--color-secondary': '#be185d',
      '--color-background': '#fdf2f8',
      '--color-background-2': '#ffffff',
      '--color-text-primary': '#831843',
      '--color-text-secondary': '#be185d',
      '--color-border': '#f9a8d4',
      '--color-landing-bg': '#fce7f3',
      '--color-landing-card': '#fbcfe8',
      '--color-landing-dark-bg': '#db2777',
      '--color-button-bg': '#be185d',
      '--color-gray-footer': '#8b174b'
    }
  },
  fuchsia: {
    name: 'ارغوانی',
    type: 'light',
    colors: {
      '--color-primary': '#d946ef',
      '--color-secondary': '#86198f',
      '--color-background': '#fdf4ff',
      '--color-background-2': '#ffffff',
      '--color-text-primary': '#701a75',
      '--color-text-secondary': '#86198f',
      '--color-border': '#f0abfc',
      '--color-landing-bg': '#fae8ff',
      '--color-landing-card': '#f5d0fe',
      '--color-landing-dark-bg': '#c026d3',
      '--color-button-bg': '#86198f',
      '--color-gray-footer': '#d946ef'
    }
  },
  purple: {
    name: 'بنفش',
    type: 'light',
    colors: {
      '--color-primary': '#8b5cf6',
      '--color-secondary': '#5b21b6',
      '--color-background': '#f5f3ff',
      '--color-background-2': '#ffffff',
      '--color-text-primary': '#4c1d95',
      '--color-text-secondary': '#5b21b6',
      '--color-border': '#ddd6fe',
      '--color-landing-bg': '#ede9fe',
      '--color-landing-card': '#ddd6fe',
      '--color-landing-dark-bg': '#7c3aed',
      '--color-button-bg': '#5b21b6',
      '--color-gray-footer': '#4e3588'
    }
  },
  violet: {
    name: 'بنفش روشن',
    type: 'light',
    colors: {
      '--color-primary': '#7c3aed',
      '--color-secondary': '#5b21b6',
      '--color-background': '#f5f3ff',
      '--color-background-2': '#ffffff',
      '--color-text-primary': '#4c1d95',
      '--color-text-secondary': '#5b21b6',
      '--color-border': '#ddd6fe',
      '--color-landing-bg': '#ede9fe',
      '--color-landing-card': '#ddd6fe',
      '--color-landing-dark-bg': '#7c3aed',
      '--color-button-bg': '#5b21b6',
      '--color-gray-footer': '#7c3aed'
    }
  },
  indigo: {
    name: 'نیلی',
    type: 'light',
    colors: {
      '--color-primary': '#6366f1',
      '--color-secondary': '#3730a3',
      '--color-background': '#eef2ff',
      '--color-background-2': '#ffffff',
      '--color-text-primary': '#312e81',
      '--color-text-secondary': '#3730a3',
      '--color-border': '#c7d2fe',
      '--color-landing-bg': '#e0e7ff',
      '--color-landing-card': '#c7d2fe',
      '--color-landing-dark-bg': '#4f46e5',
      '--color-button-bg': '#3730a3',
      '--color-gray-footer': '#5264ff'
    }
  },
  cyan: {
    name: 'فیروزه‌ای',
    type: 'light',
    colors: {
      '--color-primary': '#06b6d4',
      '--color-secondary': '#0e7490',
      '--color-background': '#ecfeff',
      '--color-background-2': '#ffffff',
      '--color-text-primary': '#164e63',
      '--color-text-secondary': '#0e7490',
      '--color-border': '#a5f3fc',
      '--color-landing-bg': '#cffafe',
      '--color-landing-card': '#a5f3fc',
      '--color-landing-dark-bg': '#0891b2',
      '--color-button-bg': '#0e7490',
      '--color-gray-footer': '#06b6d4'
    }
  },
  teal: {
    name: 'سبزآبی',
    type: 'light',
    colors: {
      '--color-primary': '#14b8a6',
      '--color-secondary': '#0f766e',
      '--color-background': '#f0fdfa',
      '--color-background-2': '#ffffff',
      '--color-text-primary': '#134e4a',
      '--color-text-secondary': '#0f766e',
      '--color-border': '#5eead4',
      '--color-landing-bg': '#ccfbf1',
      '--color-landing-card': '#99f6e4',
      '--color-landing-dark-bg': '#0d9488',
      '--color-button-bg': '#0f766e',
      '--color-gray-footer': '#14b8a6'
    }
  },
  gray: {
    name: 'خاکستری',
    type: 'light',
    colors: {
      '--color-primary': '#6b7280',
      '--color-secondary': '#374151',
      '--color-background': '#f9fafb',
      '--color-background-2': '#ffffff',
      '--color-text-primary': '#111827',
      '--color-text-secondary': '#374151',
      '--color-border': '#e5e7eb',
      '--color-landing-bg': '#f3f4f6',
      '--color-landing-card': '#e5e7eb',
      '--color-landing-dark-bg': '#4b5563',
      '--color-button-bg': '#374151',
      '--color-gray-footer': '#6b7280'
    }
  },
  slate: {
    name: 'سربی',
    type: 'light',
    colors: {
      '--color-primary': '#64748b',
      '--color-secondary': '#334155',
      '--color-background': '#f8fafc',
      '--color-background-2': '#ffffff',
      '--color-text-primary': '#0f172a',
      '--color-text-secondary': '#334155',
      '--color-border': '#e2e8f0',
      '--color-landing-bg': '#f1f5f9',
      '--color-landing-card': '#e2e8f0',
      '--color-landing-dark-bg': '#475569',
      '--color-button-bg': '#334155',
      '--color-gray-footer': '#64748b'
    }
  },
  zinc: {
    name: 'روی',
    type: 'light',
    colors: {
      '--color-primary': '#71717a',
      '--color-secondary': '#3f3f46',
      '--color-background': '#fafafa',
      '--color-background-2': '#ffffff',
      '--color-text-primary': '#18181b',
      '--color-text-secondary': '#3f3f46',
      '--color-border': '#e4e4e7',
      '--color-landing-bg': '#f4f4f5',
      '--color-landing-card': '#e4e4e7',
      '--color-landing-dark-bg': '#52525b',
      '--color-button-bg': '#3f3f46',
      '--color-gray-footer': '#71717a'
    }
  },
  neutral: {
    name: 'خنثی',
    type: 'light',
    colors: {
      '--color-primary': '#737373',
      '--color-secondary': '#404040',
      '--color-background': '#fafafa',
      '--color-background-2': '#ffffff',
      '--color-text-primary': '#171717',
      '--color-text-secondary': '#404040',
      '--color-border': '#e5e5e5',
      '--color-landing-bg': '#f5f5f5',
      '--color-landing-card': '#e5e5e5',
      '--color-landing-dark-bg': '#525252',
      '--color-button-bg': '#404040',
      '--color-gray-footer': '#737373'
    }
  },
  stone: {
    name: 'سنگی',
    type: 'light',
    colors: {
      '--color-primary': '#78716c',
      '--color-secondary': '#44403c',
      '--color-background': '#fafaf9',
      '--color-background-2': '#ffffff',
      '--color-text-primary': '#1c1917',
      '--color-text-secondary': '#44403c',
      '--color-border': '#e7e5e4',
      '--color-landing-bg': '#f5f5f4',
      '--color-landing-card': '#e7e5e4',
      '--color-landing-dark-bg': '#57534e',
      '--color-button-bg': '#44403c',
      '--color-gray-footer': '#78716c'
    }
  },
  // DARK THEMES
  dark: {
    name: 'تاریک',
    type: 'dark',
    colors: {
      '--color-primary': '#818cf8',
      '--color-secondary': '#ffffff',
      '--color-background': '#0f172a',
      '--color-background-2': '#1e293b',
      '--color-text-primary': '#f1f5f9',
      '--color-text-secondary': '#cbd5e1',
      '--color-border': '#334155',
      '--color-landing-bg': '#1e293b',
      '--color-landing-card': '#334155',
      '--color-landing-dark-bg': '#0f172a',
      '--color-button-bg': '#f1f5f9',
      '--color-gray-footer': '#3b4d65'
    }
  },
  darkBlue: {
    name: 'آبی تاریک',
    type: 'dark',
    colors: {
      '--color-primary': '#38bdf8',
      '--color-secondary': '#e0f2fe',
      '--color-background': '#0c4a6e',
      '--color-background-2': '#075985',
      '--color-text-primary': '#e0f2fe',
      '--color-text-secondary': '#bae6fd',
      '--color-border': '#0369a1',
      '--color-landing-bg': '#075985',
      '--color-landing-card': '#0369a1',
      '--color-landing-dark-bg': '#0c4a6e',
      '--color-button-bg': '#e0f2fe',
      '--color-gray-footer': '#004971'
    }
  },
  darkGreen: {
    name: 'سبز تاریک',
    type: 'dark',
    colors: {
      '--color-primary': '#34d399',
      '--color-secondary': '#dcfce7',
      '--color-background': '#064e3b',
      '--color-background-2': '#047857',
      '--color-text-primary': '#dcfce7',
      '--color-text-secondary': '#a7f3d0',
      '--color-border': '#059669',
      '--color-landing-bg': '#047857',
      '--color-landing-card': '#059669',
      '--color-landing-dark-bg': '#064e3b',
      '--color-button-bg': '#dcfce7',
      '--color-gray-footer': '#065f46'
    }
  },
  darkPurple: {
    name: 'بنفش تاریک',
    type: 'dark',
    colors: {
      '--color-primary': '#a78bfa',
      '--color-secondary': '#f5f3ff',
      '--color-background': '#4c1d95',
      '--color-background-2': '#5b21b6',
      '--color-text-primary': '#f5f3ff',
      '--color-text-secondary': '#ddd6fe',
      '--color-border': '#6d28d9',
      '--color-landing-bg': '#5b21b6',
      '--color-landing-card': '#6d28d9',
      '--color-landing-dark-bg': '#4c1d95',
      '--color-button-bg': '#f5f3ff',
      '--color-gray-footer': '#4e3588'
    }
  },
  darkRed: {
    name: 'قرمز تاریک',
    type: 'dark',
    colors: {
      '--color-primary': '#f87171',
      '--color-secondary': '#fef2f2',
      '--color-background': '#7f1d1d',
      '--color-background-2': '#991b1b',
      '--color-text-primary': '#fef2f2',
      '--color-text-secondary': '#fecaca',
      '--color-border': '#dc2626',
      '--color-landing-bg': '#991b1b',
      '--color-landing-card': '#dc2626',
      '--color-landing-dark-bg': '#7f1d1d',
      '--color-button-bg': '#fef2f2',
      '--color-gray-footer': '#991b1b'
    }
  },
  darkGray: {
    name: 'خاکستری تاریک',
    type: 'dark',
    colors: {
      '--color-primary': '#9ca3af',
      '--color-secondary': '#f9fafb',
      '--color-background': '#111827',
      '--color-background-2': '#1f2937',
      '--color-text-primary': '#f9fafb',
      '--color-text-secondary': '#e5e7eb',
      '--color-border': '#374151',
      '--color-landing-bg': '#1f2937',
      '--color-landing-card': '#374151',
      '--color-landing-dark-bg': '#111827',
      '--color-button-bg': '#f9fafb',
      '--color-gray-footer': '#4b5563'
    }
  },
  midnight: {
    name: 'نیمه‌شب',
    type: 'dark',
    colors: {
      '--color-primary': '#94a3b8',
      '--color-secondary': '#f1f5f9',
      '--color-background': '#0f172a',
      '--color-background-2': '#1e293b',
      '--color-text-primary': '#f8fafc',
      '--color-text-secondary': '#e2e8f0',
      '--color-border': '#334155',
      '--color-landing-bg': '#1e293b',
      '--color-landing-card': '#334155',
      '--color-landing-dark-bg': '#0f172a',
      '--color-button-bg': '#f1f5f9',
      '--color-gray-footer': '#475569'
    }
  },
  noir: {
    name: 'سیاه و سفید',
    type: 'dark',
    colors: {
      '--color-primary': '#ffffff',
      '--color-secondary': '#f3f4f6',
      '--color-background': '#000000',
      '--color-background-2': '#111827',
      '--color-text-primary': '#ffffff',
      '--color-text-secondary': '#e5e7eb',
      '--color-border': '#374151',
      '--color-landing-bg': '#111827',
      '--color-landing-card': '#374151',
      '--color-landing-dark-bg': '#000000',
      '--color-button-bg': '#ffffff',
      '--color-gray-footer': '#374151'
    }
  },
  amethyst: {
    name: 'آمتسیست',
    type: 'dark',
    colors: {
      '--color-primary': '#c4b5fd',
      '--color-secondary': '#f5f3ff',
      '--color-background': '#4c1d95',
      '--color-background-2': '#5b21b6',
      '--color-text-primary': '#f5f3ff',
      '--color-text-secondary': '#ddd6fe',
      '--color-border': '#6d28d9',
      '--color-landing-bg': '#5b21b6',
      '--color-landing-card': '#6d28d9',
      '--color-landing-dark-bg': '#4c1d95',
      '--color-button-bg': '#f5f3ff',
      '--color-gray-footer': '#6d28d9'
    }
  },
  sapphire: {
    name: 'یاقوت',
    type: 'dark',
    colors: {
      '--color-primary': '#60a5fa',
      '--color-secondary': '#eff6ff',
      '--color-background': '#1e3a8a',
      '--color-background-2': '#1e40af',
      '--color-text-primary': '#eff6ff',
      '--color-text-secondary': '#dbeafe',
      '--color-border': '#2563eb',
      '--color-landing-bg': '#1e40af',
      '--color-landing-card': '#2563eb',
      '--color-landing-dark-bg': '#1e3a8a',
      '--color-button-bg': '#eff6ff',
      '--color-gray-footer': '#1d4ed8'
    }
  },
  emeraldDark: {
    name: 'زمرد تاریک',
    type: 'dark',
    colors: {
      '--color-primary': '#34d399',
      '--color-secondary': '#d1fae5',
      '--color-background': '#065f46',
      '--color-background-2': '#047857',
      '--color-text-primary': '#d1fae5',
      '--color-text-secondary': '#a7f3d0',
      '--color-border': '#059669',
      '--color-landing-bg': '#047857',
      '--color-landing-card': '#059669',
      '--color-landing-dark-bg': '#065f46',
      '--color-button-bg': '#d1fae5',
      '--color-gray-footer': '#047857'
    }
  },
  ruby: {
    name: 'یاقوت سرخ',
    type: 'dark',
    colors: {
      '--color-primary': '#f87171',
      '--color-secondary': '#fee2e2',
      '--color-background': '#7f1d1d',
      '--color-background-2': '#991b1b',
      '--color-text-primary': '#fee2e2',
      '--color-text-secondary': '#fecaca',
      '--color-border': '#dc2626',
      '--color-landing-bg': '#991b1b',
      '--color-landing-card': '#dc2626',
      '--color-landing-dark-bg': '#7f1d1d',
      '--color-button-bg': '#fee2e2',
      '--color-gray-footer': '#b91c1c'
    }
  },
  amberDark: {
    name: 'کهربایی تاریک',
    type: 'dark',
    colors: {
      '--color-primary': '#fbbf24',
      '--color-secondary': '#fef3c7',
      '--color-background': '#92400e',
      '--color-background-2': '#b45309',
      '--color-text-primary': '#fef3c7',
      '--color-text-secondary': '#fde68a',
      '--color-border': '#d97706',
      '--color-landing-bg': '#b45309',
      '--color-landing-card': '#d97706',
      '--color-landing-dark-bg': '#92400e',
      '--color-button-bg': '#fef3c7',
      '--color-gray-footer': '#b45309'
    }
  },
  cyberpunk: {
    name: 'سایبرپانک',
    type: 'dark',
    colors: {
      '--color-primary': '#00ff88',
      '--color-secondary': '#00ccff',
      '--color-background': '#0a0a0f',
      '--color-background-2': '#1a1a2e',
      '--color-text-primary': '#00ff88',
      '--color-text-secondary': '#00ccff',
      '--color-border': '#ff00ff',
      '--color-landing-bg': '#1a1a2e',
      '--color-landing-card': '#16213e',
      '--color-landing-dark-bg': '#0a0a0f',
      '--color-button-bg': '#00ff88',
      '--color-gray-footer': '#00ccff'
    }
  },
  matrix: {
    name: 'ماتریکس',
    type: 'dark',
    colors: {
      '--color-primary': '#00ff00',
      '--color-secondary': '#00cc00',
      '--color-background': '#000000',
      '--color-background-2': '#0a0a0a',
      '--color-text-primary': '#00ff00',
      '--color-text-secondary': '#00cc00',
      '--color-border': '#008800',
      '--color-landing-bg': '#0a0a0a',
      '--color-landing-card': '#111111',
      '--color-landing-dark-bg': '#000000',
      '--color-button-bg': '#00ff00',
      '--color-gray-footer': '#00cc00'
    }
  },
  neon: {
    name: 'نئونی',
    type: 'dark',
    colors: {
      '--color-primary': '#ff00ff',
      '--color-secondary': '#00ffff',
      '--color-background': '#0a0a0a',
      '--color-background-2': '#1a1a1a',
      '--color-text-primary': '#ff00ff',
      '--color-text-secondary': '#00ffff',
      '--color-border': '#ff00ff',
      '--color-landing-bg': '#1a1a1a',
      '--color-landing-card': '#2a2a2a',
      '--color-landing-dark-bg': '#0a0a0a',
      '--color-button-bg': '#ff00ff',
      '--color-gray-footer': '#00ffff'
    }
  },
  // GRADIENT THEMES
  gradientSunset: {
    name: 'گرادیانت غروب',
    type: 'light',
    colors: {
      '--color-primary': 'linear-gradient(135deg, #f97316, #ec4899)',
      '--color-secondary': '#7c2d12',
      '--color-background': 'linear-gradient(135deg, #fff7ed, #fdf2f8)',
      '--color-background-2': '#ffffff',
      '--color-text-primary': '#7c2d12',
      '--color-text-secondary': '#9a3412',
      '--color-border': '#fdba74',
      '--color-landing-bg': 'linear-gradient(135deg, #fed7aa, #fbcfe8)',
      '--color-landing-card': '#ffffff',
      '--color-landing-dark-bg': '#c2410c',
      '--color-button-bg': 'linear-gradient(135deg, #f97316, #ec4899)',
      '--color-gray-footer': '#9c4a10'
    }
  },
  gradientOcean: {
    name: 'گرادیانت اقیانوس',
    type: 'light',
    colors: {
      '--color-primary': 'linear-gradient(135deg, #0ea5e9, #3b82f6)',
      '--color-secondary': '#0369a1',
      '--color-background': 'linear-gradient(135deg, #f0f9ff, #eff6ff)',
      '--color-background-2': '#ffffff',
      '--color-text-primary': '#0c4a6e',
      '--color-text-secondary': '#0369a1',
      '--color-border': '#bae6fd',
      '--color-landing-bg': 'linear-gradient(135deg, #e0f2fe, #dbeafe)',
      '--color-landing-card': '#ffffff',
      '--color-landing-dark-bg': '#0284c7',
      '--color-button-bg': 'linear-gradient(135deg, #0ea5e9, #3b82f6)',
      '--color-gray-footer': '#004971'
    }
  },
  gradientForest: {
    name: 'گرادیانت جنگل',
    type: 'light',
    colors: {
      '--color-primary': 'linear-gradient(135deg, #10b981, #84cc16)',
      '--color-secondary': '#047857',
      '--color-background': 'linear-gradient(135deg, #ecfdf5, #f7fee7)',
      '--color-background-2': '#ffffff',
      '--color-text-primary': '#064e3b',
      '--color-text-secondary': '#047857',
      '--color-border': '#a7f3d0',
      '--color-landing-bg': 'linear-gradient(135deg, #d1fae5, #ecfccb)',
      '--color-landing-card': '#ffffff',
      '--color-landing-dark-bg': '#059669',
      '--color-button-bg': 'linear-gradient(135deg, #10b981, #84cc16)',
      '--color-gray-footer': '#106d32'
    }
  },
  gradientRoyal: {
    name: 'گرادیانت سلطنتی',
    type: 'light',
    colors: {
      '--color-primary': 'linear-gradient(135deg, #8b5cf6, #ec4899)',
      '--color-secondary': '#5b21b6',
      '--color-background': 'linear-gradient(135deg, #f5f3ff, #fdf2f8)',
      '--color-background-2': '#ffffff',
      '--color-text-primary': '#4c1d95',
      '--color-text-secondary': '#5b21b6',
      '--color-border': '#ddd6fe',
      '--color-landing-bg': 'linear-gradient(135deg, #ede9fe, #fce7f3)',
      '--color-landing-card': '#ffffff',
      '--color-landing-dark-bg': '#7c3aed',
      '--color-button-bg': 'linear-gradient(135deg, #8b5cf6, #ec4899)',
      '--color-gray-footer': '#4e3588'
    }
  },
  gradientFire: {
    "name": "گرادیانت آتش",
    "type": "light",
    "colors": {
      "--color-primary": "linear-gradient(135deg, #f59e0b, #ef4444)",
      "--color-secondary": "#92400e",
      "--color-background": "linear-gradient(135deg, #fffbeb, #fef2f2)",
      "--color-background-2": "#ffffff",
      "--color-text-primary": "#78350f",
      "--color-text-secondary": "#92400e",
      "--color-border": "#fbbf24",
      "--color-landing-bg": "linear-gradient(135deg, #fef3c7, #fee2e2)",
      "--color-landing-card": "#ffffff",
      "--color-landing-dark-bg": "#d97706",
      "--color-button-bg": "linear-gradient(135deg, #f59e0b, #ef4444)",
      "--color-gray-footer": "#7f5700"
    }
  }
};

import shopService from "../api/services/shopService" // سرویس جستجو

export async function applyTheme(themeKey) {
  // const theme = themes[themeKey] || themes.light
  const shop =await shopService.getStore()
  localStorage.setItem('siteInfo', JSON.stringify(shop))
  const theme = shop.theme_setting

  const root = document.documentElement

  Object.entries(theme.colors).forEach(([key, value]) => {
    root.style.setProperty(key, value)
  })

  localStorage.setItem('selectedTheme', themeKey)
}

export function loadSavedTheme() {
  const savedTheme = localStorage.getItem('selectedTheme') || 'light'
  applyTheme(savedTheme)
}

